import { Box, Flex, Text, Icon, Collapsible } from '@chakra-ui/react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'
import { useState, type ReactNode } from 'react'

interface CollapsibleSectionProps {
  title: string
  defaultOpen?: boolean
  children: ReactNode
}

export function CollapsibleSection({
  title,
  defaultOpen = false,
  children,
}: CollapsibleSectionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  return (
    <Box borderBottom="1px" borderColor="gray.100" pb={2} mb={1}>
      <Flex
        align="center"
        justify="space-between"
        cursor="pointer"
        py={2}
        onClick={() => setIsOpen(!isOpen)}
        _hover={{ bg: 'gray.50' }}
        borderRadius="md"
        px={1}
        userSelect="none"
      >
        <Text fontSize="xs" fontWeight="bold" color="gray.500" textTransform="uppercase" letterSpacing="wider">
          {title}
        </Text>
        <Icon
          as={isOpen ? FiChevronUp : FiChevronDown}
          boxSize={4}
          color="gray.400"
        />
      </Flex>
      <Collapsible.Root open={isOpen}>
        <Collapsible.Content>
          <Box pt={1}>{children}</Box>
        </Collapsible.Content>
      </Collapsible.Root>
    </Box>
  );
}
